import { dictionaryCamelCaseConverter } from 'src/utils/dictionaryCamelCaseConverter';

export const sanitizeSalutations = (data) => dictionaryCamelCaseConverter(data);
